/*
 * spec-tip-portal.js — renders .crc__tip content as a body-level fixed
 * tooltip so it escapes overflow:hidden ancestors (carousels, card grids).
 *
 * The source .crc__tip <span> stays in the DOM as the tip's text source
 * (authoring lives in snippets/spec-tag.liquid). CSS hides it; this script
 * copies its text into a shared portal element on hover/focus.
 */
(function () {
  'use strict';
  if (window.__specTipPortalInit) return;
  window.__specTipPortalInit = true;

  // Hover devices get hover/focus behaviour; touch devices get explicit tap-to-toggle.
  var hasHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  var portal = null;
  var currentTag = null;
  var hideTimer = null;

  function ensurePortal() {
    if (portal) return portal;
    portal = document.createElement('div');
    portal.className = 'spec-tip-portal';
    portal.setAttribute('role', 'tooltip');
    portal.setAttribute('aria-hidden', 'true');
    document.body.appendChild(portal);
    return portal;
  }

  function position(tag, tip) {
    var rect = tag.getBoundingClientRect();
    var tw = tip.offsetWidth;
    var th = tip.offsetHeight;
    var vw = document.documentElement.clientWidth;
    var margin = 8;
    var gap = 9;

    var left = rect.left + rect.width / 2 - tw / 2;
    var top = rect.top - th - gap;
    var below = false;
    if (top < margin) { top = rect.bottom + gap; below = true; }
    if (left < margin) left = margin;
    var maxLeft = vw - tw - margin;
    if (left > maxLeft) left = maxLeft;

    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
    tip.classList.toggle('spec-tip-portal--below', below);
  }

  function show(tag) {
    var src = tag.querySelector('.crc__tip');
    if (!src) return;
    var text = (src.textContent || '').trim();
    if (!text) return;
    clearTimeout(hideTimer);
    var tip = ensurePortal();
    tip.textContent = text;
    tip.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      position(tag, tip);
      tip.classList.add('is-visible');
    });
    currentTag = tag;
  }

  function hide() {
    if (!portal) return;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      portal.classList.remove('is-visible');
      portal.setAttribute('aria-hidden', 'true');
      currentTag = null;
    }, 60);
  }

  if (hasHover) {
    document.addEventListener('mouseover', function (e) {
      var tag = e.target.closest && e.target.closest('.crc__tag--feat, .crc-feat__item');
      if (tag && tag !== currentTag) show(tag);
    });
    document.addEventListener('mouseout', function (e) {
      var tag = e.target.closest && e.target.closest('.crc__tag--feat, .crc-feat__item');
      if (!tag) return;
      if (e.relatedTarget && tag.contains(e.relatedTarget)) return;
      hide();
    });
    document.addEventListener('focusin', function (e) {
      var tag = e.target.closest && e.target.closest('.crc__tag--feat, .crc-feat__item');
      if (tag) show(tag);
    });
    document.addEventListener('focusout', function (e) {
      var tag = e.target.closest && e.target.closest('.crc__tag--feat, .crc-feat__item');
      if (tag) hide();
    });
  } else {
    document.addEventListener('click', function (e) {
      var tag = e.target.closest && e.target.closest('.crc__tag--feat, .crc-feat__item');
      if (tag) {
        if (tag === currentTag && portal && portal.classList.contains('is-visible')) hide();
        else show(tag);
      } else if (currentTag) {
        hide();
      }
    });
  }
  var lastShowAt = 0;
  var origShow = show;
  show = function (tag) {
    lastShowAt = Date.now();
    origShow(tag);
  };
  // A finger drag is a real scroll — close immediately. Scroll *events* alone
  // get a grace period: iOS smooth-scrolls the focused tag into view right
  // after the opening tap, and that programmatic scroll has no touchmove.
  document.addEventListener('touchmove', function () {
    if (currentTag) hide();
  }, { passive: true });
  function hideUnlessJustShown() {
    if (currentTag && Date.now() - lastShowAt > 600) hide();
  }
  window.addEventListener('scroll', hideUnlessJustShown, { passive: true, capture: true });
  window.addEventListener('resize', hideUnlessJustShown, { passive: true });
})();
